/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CostDataRecord } from '../models/CostDataRecord';

export class QueryCostDataResponse {
  /**
  * Array of cost data records matching the requested query criteria. Each record contains cost and usage information grouped by the specified dimensions and time granularity. 
  */
  'records': Array<CostDataRecord>;
  /**
  * Total number of cost records that matched the time frame and filter options. 
  */
  'totalCount': number;
  /**
  * Total number of unique resources in time range
  */
  'totalUniqueResources': number;
  /**
  * Total number of resources that incurred costs during the specified time frame. 
  */
  'resourceCount': number;
  /**
  * Cursor that points to the first record of the next page of results. Pass this value in the next request. 
  */
  'nextToken'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "records",
      "baseName": "records",
      "type": "Array<CostDataRecord>",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "totalUniqueResources",
      "baseName": "totalUniqueResources",
      "type": "number",
      "format": ""
    },
    {
      "name": "resourceCount",
      "baseName": "resourceCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return QueryCostDataResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

